import * as ACTIONTYPES from '../constants/actiontypes';

import {
  togglePlay
} from './index';

import {
  getViewMode,
} from '../selectors/selectors';

import {
  hideControls,
  showControls,
} from './controls-visibility-actions';


export const changeViewMode = viewMode => ({
  type: ACTIONTYPES.CHANGE_VIEW_MODE,
  viewMode,
});

export const switchMode = mode => (dispatch, getState) => {
  const state = getState();
  const viewMode = getViewMode(state);
  if (viewMode === mode) {
    return;
  }

  dispatch(hideControls());

  setTimeout(() => {
    if (mode === 'text') {
      dispatch(togglePlay(false))
    } else {
      dispatch(togglePlay(true))
    }
    dispatch(changeViewMode(mode));
    dispatch(showControls());
  }, 500);
};


// WEBPACK FOOTER //
// ./src/store/actions/mode-switcher-actions.js